import type { TOC } from '@ember/component/template-only'
import { ThStandard } from 'teacher-ui-client/components/th/standard'
import type { AssessmentsEventsReportData } from 'teacher-ui-client/reporting/ui-scope/rex/dashboard/student/index/route'
import { t, formatDate } from 'ember-intl'
import { concat } from '@ember/helper'
import { colspanMax } from 'teacher-ui-client/modifiers/colspan-max'
import { formatValue } from 'teacher-ui-client/utils/format-value'

interface Args {
  isLoading?: boolean
  eventsData: AssessmentsEventsReportData['events']
}

interface Signature {
  Args: Args
  Element: HTMLTableElement
}
export const StudentAssessmentsEvents: TOC<Signature> = <template>
  <table class="divide-oceany-blue-150 border-oceany-blue-150 divide-y border-b" ...attributes>
    <thead>
      <tr>
        <ThStandard class="w-40">
          {{t "components.reporting.tables.readingEggspress.dashboardStudent.headers.date"}}
        </ThStandard>
        <ThStandard>
          {{t "components.reporting.tables.readingEggspress.dashboardStudent.headers.classification"}}
        </ThStandard>
        <ThStandard>
          {{t "components.reporting.tables.readingEggspress.dashboardStudent.headers.lexile"}}
        </ThStandard>
        <ThStandard>
          {{t "components.reporting.tables.readingEggspress.dashboardStudent.headers.score"}}
        </ThStandard>
      </tr>
    </thead>
    <tbody class="divide-oceany-blue-150 divide-y {{if @isLoading 'opacity-50'}}">
      {{#each @eventsData as |event|}}
        <tr>
          <td class="p-3">{{formatDate event.created_at day="2-digit" month="short" year="numeric"}}</td>
          <td class="p-3">{{t (concat "classifications." event.classification)}}</td>
          {{! template-lint-disable no-bare-strings }}
          <td class="p-3">{{formatValue event.lexile append="L"}}</td>
          <td class="p-3">{{formatValue event.score append="%"}}</td>
        </tr>
      {{else}}
        <tr>
          <td data-test-empty-message class="p-3 text-center italic" {{colspanMax}}>
            {{t "components.reporting.tables.readingEggspress.dashboardStudent.eventsEmptyMessage"}}
          </td>
        </tr>
      {{/each}}
    </tbody>
  </table>
</template>

export default StudentAssessmentsEvents
